
import { useState, useRef } from 'react';
import { Grid } from '@mui/material';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';


function DateSelectorSingle({ date, setDate }) {
  const [open, setOpen] = useState(false);
  // To focus input after selection (optional)
  const inputRef = useRef(null);
  return (
    <Grid item sx={4} style={{ display: 'flex', margin: '25px', alignItems: 'center', gap: '10px' }}>
      <Localization
        date={
          new DateLocalizer({
            culture: 'pl-PL',
            firstOfWeek: 1,
          })
        }
      >
        <DatePicker
          value={date}
          valueEditFormat={{ dateStyle: 'long' }}
          valueDisplayFormat={{ dateStyle: 'long' }}
          placeholder='Data'
          onChange={(value) => {
            setDate(value);
            setOpen(false);
          }}
          open={open}
          onToggle={setOpen}
          inputProps={{
            readOnly: true,
            ref: inputRef,
            onClick: () => setOpen(true),
            style: { cursor: 'pointer', width: '250px' },
          }}
        />
      </Localization>
    </Grid>
  );
}

export { DateSelectorSingle };

